export default __webpack_public_path__ + "static/media/32.af2a2203.png";